export default "__VITE_ASSET__DFkvCe7v__"